<template>
  <a-row>
    <a-col :xs="24" :sm="24" :md="span" :lg="span" :xl="span" style="padding: 4px 0px 4px 0px;">
      <slot name="search">
      </slot>
    </a-col>
    <a-col :xs="24" :sm="24" :md="span" :lg="span" :xl="span" style="padding: 0px 0px;">
      <slot name="filter">
      </slot>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'SearchPanel',
  data() {
    return {
      span: 12
    }
  },
  props: {
    mode: {
      type: String,
      default: function() {
        return 'inline'
      }
    }
  },
  created() {
    if (this.mode == 'inline') {
      this.span = 12;
    } else {
      this.span = 24;
    }
  }
}
</script>

<style>
</style>
